var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-checkbox',{staticClass:"theme-toggle",class:_vm.$store.state.theme,attrs:{"switch":""},on:{"change":_vm.changeTheme},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},[_vm._v(" Modo "+_vm._s(_vm.value ? "escuro" : "claro")+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }